import React from 'react';
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import './questions.css'

export default function Questions() {
    return (
        <section id='questions'>
        <h2>GX FAQ</h2>
            <Accordion allowZeroExpanded>
            <AccordionItem>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            How many GX are there?
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        <p>
                        96.
                        </p>
                    </AccordionItemPanel>
                </AccordionItem>
                <AccordionItem>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            Why no helmet/plate/belt?
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        <p>
                            Simply, as they are the most common occurrences. GX is a look into budz without those.<br></br>In the weeks and months after mint, some collectors were discovering these budz without any of the three most common gadgets. GX builds upon that early foundation.<br></br>Anybody can create a defined sub-rarity within any project or community.<br></br>GX is a display of exploration and passion toward sharing and building.
                        </p>
                    </AccordionItemPanel>
                </AccordionItem>
                <AccordionItem>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            Where does the name come from?
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        <p>
                        "GX" uses the "g" from "gadget", commonly used to refer to trait (gadget) counts (1g, 2g, 3g, ...),<br></br> and the "x" identifes the absence of the three most common gadgets (Belt, Chestplate, Covered Helmet).
                        </p>
                    </AccordionItemPanel>
                </AccordionItem>
                <AccordionItem>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            Which animals and gadgets don't exist as GX, and which have only singular occurrences?
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        <p>
                        Not as GX:<br></br>
                        - Bulls, Wolves.<br></br>
                        - In addition to the Covered Helmet, Chestplate, Belt; SPO, Star Suit, Camo Suit.<br></br><br></br>
                        Single Occurrences (only one of each):<br></br>
                        - Dino, Rhino, Shark.<br></br>
                        - Binoculars, Candle, Flag, Jetpack.
                        </p>
                    </AccordionItemPanel>
                </AccordionItem>
                <AccordionItem>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            What is GX Collective?
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        <p>
                        GX Collective is derivative artwork conceptualised and offered to GX members, by artists/teams within the ecosystem.<br></br>A percentage from each derivative mint price is donated to the <a href="https://pool.pm/$spacebudznft" target='_blank' rel="noreferrer">SpaceBudz Multi-sig Community Wallet.</a><br></br> <a href="https://fort-gotten.webflow.io/collabs/gx-budz" target='_blank' rel="noreferrer">Set 1</a> was created by <a href="https://twitter.com/fortgotten" target='_blank' rel="noreferrer">Fort Gotten</a>. <br></br> Set 2 was created collectively by owners using AI generated images of their GX from <a href="https://openai.com/dall-e-2/" target='_blank' rel="noreferrer">DALL-E</a>.
                        </p>
                    </AccordionItemPanel>
                </AccordionItem>
                <AccordionItem>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            Where can I see current GX market prices?
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        <p>
                        The following links will open a new window to the official SpaceBudz.io marketplace:<br></br> GX (96 only) - <a href="https://spacebudz.io/explore/?gadget=NOT_Belt&gadget=NOT_Chestplate&gadget=NOT_Covered%20Helmet&gadgetsCount=1&gadgetsCount=MAX&sort=ASC_BUY" target='_blank' rel="noreferrer">Filtered by price</a> <br></br>Current market listings (whole collection): <a href="https://spacebudz.io/explore/?sort=ASC_BUY">All - Filtered by price</a>
                        </p>
                    </AccordionItemPanel>
                </AccordionItem>
            </Accordion>
        </section>
    );
}